import React from 'react';
import { Button, Clickable, Input, LoadingBalls, Overlay, Stack, Text } from '@moda/om';
import ExitIcon from '@moda/icons/exit-16';
import { tc } from '../../lib/trackingContext';
import { useContactToPurchaseForm } from './useContactToPurchaseForm';

import './ContactToPurchaseForm.scss';

type Props = { onSuccess: () => void; onClose: () => void };

export const ContactToPurchaseForm: React.FC<Props> = ({ onSuccess, onClose }) => {
  const { handleSubmit, formErrors, error, loading } = useContactToPurchaseForm({ onSuccess });

  const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleSubmit(event);
  };

  const handleModalClose = () => {
    onClose();
    tc.track('Contact To Purchase Closed', {
      addToTrackingEvent: {
        label: 'X',
        location: 'Contact To Purchase Form Close button',
        form_location: location.pathname
      }
    });
  };

  return (
    <form className="ContactToPurchaseForm" onSubmit={handleFormSubmit}>
      <Clickable
        className="ContactToPurchaseForm__close"
        aria-label="Close"
        onClick={handleModalClose}
      >
        <ExitIcon />
      </Clickable>

      <Stack space={5}>
        <Stack space={4}>
          <Text className="ContactToPurchaseForm__title" treatment="h3" family="serif">
            Contact Us To Purchase
          </Text>
          <Text className="ContactToPurchaseForm__description">
            Please provide your information below and we will will get back to you with further
            details.
          </Text>

          <Input label="Full Name" name="name" error={formErrors.name?.message} />
          <Input label="Email" name="email" error={formErrors.email?.message} />
          <Input label="Phone Number" name="phone" />
          <Input label="Notes for Moda" name="notes" />
        </Stack>
        {error && <Text color="code-red">{error.message}</Text>}
        <Button type="submit" className="ContactToPurchaseForm__submit">
          Submit
        </Button>
      </Stack>

      <Overlay show={loading}>
        <LoadingBalls />
        <Text treatment="eyebrow">Sending</Text>
      </Overlay>
    </form>
  );
};
